import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InjectorInstance } from '@app/injector.module';

@Injectable()
export class MatPaginatorIntlPL extends MatPaginatorIntl {

  constructor() {
    super();
    const translate = InjectorInstance.get(TranslateService);
    translate.get('paginator').subscribe((translation: any) => {
      this.itemsPerPageLabel = translation.resultsPerPage;
      this.firstPageLabel = translation.firstPage;
      this.lastPageLabel = translation.lastPage;
      this.nextPageLabel = translation.nextPage;
      this.previousPageLabel = translation.prevPage;
    });
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 z ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} z ${length}`;
  };
}
